export const PRIMARY_QUOTE_SYMBOLS = {
  honey: 'HONEY',
  usdb: 'USDB',
  usdc: 'USDC',
  usdce: 'USDC.e',
  usdt0: 'USDT0',
};
